/**

1. Provide your resources in a global config file
2. Provide a request in your data:
3. Feed that request into your desired method.

e.g.:

```
data () {
  return requests: {
    foo: {
      resource:
    }
  }
}
```
 */
import axios from 'axios'
import Vue from 'vue'

const SERVICES = {
  authenticationguru: process.env.VUE_APP_AUTHENTICATIONGURU_API_ROOT,
  appointmentguru: process.env.VUE_APP_APPOINTMENTGURU_API_ROOT,
  contentguru: process.env.VUE_APP_CONTENTGURU_API_ROOT,
  subscriptionguru: process.env.VUE_APP_SUSCRIPTIONGURU_API_ROOT
}

const RESOURCE = {
  'subscriptionguru.transactions': {
    base: SERVICES.subscriptionguru,
    path: '/api/transactions/'
  },
  // authguru:
  'auth.login': {
    base: SERVICES.authenticationguru,
    path: '/login/'
  },

  // AppointmentGuru
  'ag.auth': {
    base: SERVICES.appointmentguru,
    path: '/api/auth/'
  },
  'ag.appointments': {
    base: SERVICES.appointmentguru,
    path: '/api/appointments/'
  },
  'ag.team': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/team/'
  },
  'ag.business': {
    base: SERVICES.appointmentguru,
    path: '/api/business/'
  },
  'ag.practitioner.me': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/practitioners/me/'
  },
  'ag.v2.practitioner.me': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/me/'
  },
  'ag.user': {
    base: SERVICES.appointmentguru,
    path: '/api/users/'
  },
  'ag.practitioner': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/practitioners/'
  },
  'ag.practitioner.profile': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/me/profile/'
  },
  'ag.practitioner.profile.smartsettings': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/smartsettings/'
  },
  'ag.practitioner.me.lookup': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/practitioners/me/lookups/'
  },
  'ag.practitioner.appointments': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/appointments/'
  },
  'practitioner.professions': {
    base: SERVICES.appointmentguru,
    path: '/api/practitioners/professions/'
  },
  'ag.practitioner.rules': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/rules/'
  },
  'ag.v2.practitioner.services': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/services/'
  },
  'ag.practitioner.hours': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/services/hours/'
  },
  'ag.practitioner.notifications': {
    base: SERVICES.appointmentguru,
    path: '/api/practitioners/settings/messages/'
  },
  'ag.spaces.practitioner': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/spaces/'
  },
  'ag.spaces.relationships': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/relationships/',
    detailMutation: 'addClientDetail'
  },
  'ag.spaces.products': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/services/products/'
  },
  'ag.spaces.products.v3': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/practitioner/appointment-types/'
  },
  'ag.spaces.settings': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/settings/'
  },
  'ag.spaces.members': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/members/'
  },
  'ag.spaces.appointmenttypes': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/appointment-types/'
  },
  'ag.spaces.addresses': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/:spaceId/addresses/'
  },
  'ag.spaces': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/spaces/'
  },
  'ag.integrations': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/integrations/'
  },
  'ag.integrations.setmore': {
    base: SERVICES.appointmentguru,
    path: '/api/v2/practitioner/integrations/setmore/'
  },
  'ag.actions': {
    base: SERVICES.appointmentguru,
    path: '/api/v3/actions/'
  },
  // unibox:
  'unibox.templates': {
    base: SERVICES.unibox,
    path: '/templates/'
  },
  'unibox.comms': {
    base: SERVICES.unibox,
    path: '/communications/'
  },
  // invoiceguru:
  'invoiceguru.transactions': {
    base: SERVICES.invoiceguru,
    path: '/transactions/'
  },
  'invoiceguru.invoices': {
    base: SERVICES.invoiceguru,
    path: '/invoices/'
  },
  // CONTENTGURU
  'contentguru.websites': {
    base: SERVICES.contentguru,
    path: '/api/websites/'
  }
}

function getUrl(resource, resourceId = null, actionId = null, extra = null, kwargs = null) {
  if (!(resource in RESOURCE)) {
    console.error(resource + ' not found in RESOURCE')
    console.error(RESOURCE)
  }
  let config = RESOURCE[resource]

  if (!('base' in config)) {
    console.error('base not defined in config: ', config)
  }
  let resourceUrl = `${config.base}${config.path}`

  if (resourceId) {
    resourceUrl += resourceId + '/'
  }
  if (actionId) {
    resourceUrl += 'actions/' + actionId + '/'
  }
  if (extra) {
    resourceUrl += extra + '/'
  }
  if (kwargs) {
    Object.keys(kwargs).forEach((k) => {
      resourceUrl = resourceUrl.replace(`:${k}`, kwargs[k])
    })
  }
  return resourceUrl
}

export default {
  data() {
    return {
      $RESOURCES: RESOURCE
    }
  },
  methods: {
    requestAuthHeaders(service = null) {
      if (service) {
        console.log(service)
      }
      let headers = {
        authorization: 'Bearer ' + this.$store.getters['auth/auth'],
        'content-type': 'application/json'
      }
      return headers
    },
    async makeRequest(config, options) {
      try {
        if (options && options.method === 'get' && config.loading && (!config.params || Object.keys(config.params).length === 0)) {
          console.log('skipping request GET ' + config.url)
          return null
        }
        Vue.set(config, 'loading', true)
        Vue.set(config, 'status', '0')
        Vue.set(config, 'errors', {})

        if (options.params) {
          options.params = new URLSearchParams(options.params)
        }
        if (options.url && options.url.indexOf('authguru.') !== -1) {
          options.withCredentials = true
          options.headers['X-CSRFToken'] = this.$cookies.get('_csrftoken')
        }
        let res = await axios(options)
        if (res && res.status) {
          if (res.status > 199) {
            Vue.set(config, 'result', res.data)
            Vue.set(config, 'status', res.status)
            Vue.set(config, 'error', false)
            Vue.set(config, 'loading', false)
            if (RESOURCE[config.resource].detailMutation) {
              if (config.resourceId && !config.extra) {
                this.$store.commit(RESOURCE[config.resource].detailMutation, res.data)
              }
            }
          }
        }
        return res
      } catch (error) {
        Vue.set(config, 'errors', error.response.data)
        Vue.set(config, 'status', error.response.status)

        if (error.response.status === 401) {
          // if (error.response.detail === 'Authentication credentials were not provided.') {
          if (this.$router.path !== '/login') {
            this.$store.dispatch('auth/logUserOut', this.$route.path)
            this.$router.push('/login')
          }
          // }
        }
        if (error.response) { // non 2xx status code
          Vue.set(config, 'errors', error.response.data)
          Vue.set(config, 'status', error.response.status)
        } else if (error.request) { // The request was made but no response was received
          Vue.set(config, 'errors', { message: 'Server error occured' })
          Vue.set(config, 'status', 500)
        } else {
          Vue.set(config, 'status', 500)
        }
        Vue.set(config, 'error', true)
        Vue.set(config, 'loading', false)
      }
    },
    async $request(action, config) {
      /* this.request('get', config) */
      if (action === 'get') {
        return this.__fetch(config)
      }
      if (action === 'save') {
        return this.__save(config)
      }
      if (action === 'delete') {
        return this.__delete(config)
      }
      console.error(`${action} is not a supported action. Try: 'get', 'save'`)
    },
    async __fetch(config) {
      /*
       * Perform a GET request.
       * Usage:
       * :param config: config is a request definition
       * let options = { resource: 'ag.spaces', resourceId: 9, extra: 'stream/'}
       * fetch(options) // GET /api/v3/practitioner/spaces/9/stream/
       *
       */
      let url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs)
      let headers = this.requestAuthHeaders()
      let method = 'get'
      let params = {}
      if (config.params) {
        params = config.params
      }
      let options = { url, headers, method, params }
      return this.makeRequest(config, options)
    },
    async __delete(config) {
      let url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs)
      let headers = this.requestAuthHeaders()
      let method = 'delete'
      let params = {}
      if (config.params) {
        params = config.params
      }
      let data = {}
      if (config.data) {
        data = config.data
      }
      let options = { url, headers, method, params, data }
      return this.makeRequest(config, options)
    },
    async __save(config) {
      let url = getUrl(config.resource, config.resourceId, null, config.extra, config.kwargs)
      let headers = this.requestAuthHeaders()
      let method = 'post'
      if (config.resourceId) {
        method = 'patch'
      }
      if (config.method) { // if explicitly specified overwrite implicit
        method = config.method
      }
      let params = {}
      if (config.params) {
        params = config.params
      }
      let data = {}
      if (config.data) {
        data = config.data
      }
      let options = { url, headers, method, params, data }
      return this.makeRequest(config, options)
    },
    // /api/v3/admin/practitioners/1/actions/convert_practitioner/
    async getAction(config) {
      return this.performAction(config, {}, 'get')
    }
    // async performAction (config, data = {}, method = 'post') {
    //   let url = getUrl(config.resource, config.resourceId, config.actionId)
    //   let headers = this.requestAuthHeaders()
    //   let options = { url, headers, method, data }
    //   return this.makeRequest(config, options)
    // }
  }
}
